import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * A season's value for a catalog rule. The GET endpoint returns one row per active
 * catalog rule (key/label/default from `rule`), with `season_rule_id`/`rule_value`
 * present only when this season already stored a value.
 */
export interface SeasonRuleItem {
    season_rule_id?: number;
    season_id:       number;
    rule_id:         number;
    rule_key:        string;
    rule_label:      string;
    default_value?:  string | null;
    rule_value?:     string | null;
    sort_order?:     number;
    is_favorite?:    number;   // from the catalog; 1 = prefilled as Renndetail on new Anmelde-Fenster
}

@Injectable()
export class SeasonRulesService {
    private apiUrl = `${environment.apiBaseUrl}/api/seasonRulesCrud.php`;

    constructor(private http: HttpClient) {}

    getRules(season_id: number): Observable<SeasonRuleItem[]> {
        return this.http.get<SeasonRuleItem[]>(`${this.apiUrl}?season_id=${season_id}`);
    }

    /** Upsert a season's value for a rule (keyed on season_id + rule_id server-side). */
    saveRule(rule: { season_id: number; rule_id: number; rule_value?: string | null }): Observable<SeasonRuleItem> {
        return this.http.post<SeasonRuleItem>(this.apiUrl, rule);
    }

    deleteRule(season_rule_id: number): Observable<{ success: boolean }> {
        return this.http.delete<{ success: boolean }>(this.apiUrl, { body: { season_rule_id } });
    }
}
